// NNHC design system — single source of truth for colors, typography, radii, shadows.
export const theme = {
  colors: {
    purple: '#6B2D9E',
    purpleDark: '#4A1F6B',
    purpleTint: '#F5F0FA',
    gold: '#C9922A',
    goldLight: '#F5E6C4',
    offWhite: '#FAF7FC',
    white: '#FFFFFF',
    gray: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      500: '#6B7280',
      900: '#111827',
    },
    success: '#16A34A',
    warning: '#EAB308',
    error: '#DC2626',
  },
  fonts: {
    heading: "'Comfortaa', cursive",
    body: "'DM Sans', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  radii: { sm: 4, md: 8, lg: 12, xl: 16 },
  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 15px rgba(0,0,0,0.1)',
  },
};

// Process-stage chip colors (used in Active Patients modal)
export const stageChip = {
  draft:           { bg: '#E5E7EB', fg: '#374151', label: 'Draft' },
  submitted:       { bg: '#DBEAFE', fg: '#1E40AF', label: 'Submitted' },
  uploaded_to_cv:  { bg: '#EDE9FE', fg: '#6D28D9', label: 'Uploaded to CV' },
  qa_approved:     { bg: '#DCFCE7', fg: '#166534', label: 'QA Approved' },
  purge_eligible:  { bg: '#FFEDD5', fg: '#9A3412', label: 'Purge Eligible' },
  purged:          { bg: '#F3F4F6', fg: '#9CA3AF', label: 'Purged' },
};
